import { expressQuerySelector, htmlToElement } from "../common/html";
import { getIcon, getIconsAsync } from "../services/content-service";

export function loadSvgIcons(iconEls: HTMLElement[]) {
	if (iconEls && iconEls.length > 0) {
		const iconContentKeyDataAttribute = "data-iconcontentkey";
		const iconsWithoutSvg = iconEls.filter((el) => !expressQuerySelector(el, "svg", false));
		const iconKeys = iconsWithoutSvg.map((el) => el.dataset.iconcontentkey || "");
		getIconsAsync(iconKeys.filter((x, i, a) => a.indexOf(x) == i)).then((_) => {
			iconsWithoutSvg.forEach((el) => {
				if (el.hasAttribute(iconContentKeyDataAttribute)) {
					const iconContentKey = el.dataset.iconcontentkey || "";
					const iconFill = el.dataset.iconfill || "";
					if (iconContentKey) {
						const icon = getIcon(iconContentKey.toLocaleLowerCase().replace("icon.", ""));
						if (icon) {
							fetch(icon)
								.then((response) => response.text())
								.then((svg) => {
									if (svg) {
										if (iconFill) {
											svg = svg.replace("<svg", '<svg style="fill:' + iconFill + '"');
										}
										const iEl = expressQuerySelector<HTMLElement>(el, ".technical-icon-file", false);
										if (iEl && !iEl.innerText) iEl.insertAdjacentHTML("afterbegin", svg);
									}
								});
						}
					}
				}
			});
		});
	}
}
